/* Personalization Customizer */

import { KLCustomizer } from 'kl-customizer';

class KlPersonalizationCustomizer extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.formId = this.getAttribute('form-id');
    this.scope = KLCustomizer.scopeFrom(this);

    KLCustomizer.wireScope(this, this.scope, this.abortController.signal);
    this.#refresh();
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  onScopeChange(scope, event) {
    const input = event.target;

    if ('nativeOption' in input.dataset) {
      KLCustomizer.selectNativeOption(this.formId, input.value);
    }

    this.#refresh();
  }

  #refresh() {
    KLCustomizer.refresh(this.scope);

    const withPerso = KLCustomizer.withPerso(this.scope);
    this.querySelectorAll('[data-pattern], [data-font]').forEach((input) => (input.disabled = !withPerso));
  }
}

if (!window.customElements.get('kl-personalization-customizer')) {
  window.customElements.define('kl-personalization-customizer', KlPersonalizationCustomizer);
}
